<template>

    <div class="pt-8">
        <template>
            <v-overlay :value="loader">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </template>
        <filter-form 
            :filter="filter" 
            @get-companies="getCompanies()" 
            @clear-filter-form="clearFilterForm()" 
        />
        
        <companies-table 
            :companies="companies" 
            :paginator="paginator" 
            :pageSize="pageSize" 
            @get-companies="getCompanies()" 
            @change-page="changePage($event)" 
        />
           
        
    </div>
</template>
<script>
import { mapMutations } from 'vuex'
import FilterForm from '../components/FilterForm.vue'
import CompaniesTable from '../components/CompaniesTable.vue'
export default {
    data(){
        return{
            companies: [],
            loader: false,
            paginator: {
                page: 1,
                totalPage: 1,
                pageSize: 10,
            },
            pageOptions: "",
            pageSize: [10, 25, 50, 100],
            filter:{
                companyName: "",
                companyNit: "",
            },
        }
    },
    components: {
        FilterForm,
        CompaniesTable
    },

    created(){
        this.getCompanies();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getCompanies(){
            this.pageOptions = { 
                                pageNumber: this.paginator.page, 
                                pageSize: this.paginator.pageSize,
                                nombre: this.filter.companyName,
                                nit: this.filter.companyNit,
                                }
            this.setLoading(true)
            await this.$conectar.post('/admin/empresas/get-empresas-by-admin', this.pageOptions)
            .then(response =>{
                this.companies = response.data.empresasLists;
                this.paginator.totalPage = response.data.totalPages;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        changePage(page){
            this.paginator.page = page;
            this.getCompanies();
        },
        clearFilterForm(){
            this.filter.companyName = "";
            this.filter.companyNit = "";
            this.paginator.pageSize = 10;
        },
    }
}
</script>